(() => {
  if (window.__modamoreRouterInit) return;
  window.__modamoreRouterInit = true;

  const root = document.querySelector('[data-modamore-section]');
  const current = document.currentScript;
  if (!current || !current.src) return;

  const loadSibling = name => {
    const script = document.createElement('script');
    script.src = current.src.replace(/modamore\.js(?:\?.*)?$/, name);
    script.defer = true;
    document.head.appendChild(script);
  };

  if (root) {
    window.__modamoreUiInit = true;
    const cta = document.getElementById('ctaButtonLabel');
    if (cta && !/sold out/i.test(cta.textContent || '')) cta.textContent = 'ADD TO BAG';
    loadSibling('modamore-core.js');
    return;
  }

  loadSibling('modamore-home.js');
})();
